export const playlist = {
  'Public playlist': 'Public playlist',
  songs: 'songs',
  Name: 'Name',
  Filter: 'Filter',
  'Date Added': 'Date Added',
  'Add to playlist': 'Add to playlist',
  'Remove from this playlist': 'Remove from this playlist',
  'Added to playlist': 'Added to playlist',
  'Added to queue': 'Added to queue',
  'Removed from playlist': 'Removed from playlist',
  'Add to queue': 'Add to queue',
  'Go to album': 'Go to album',
  'Go to artist': 'Go to artist',
  Title: 'Title',
  Album: 'Album',
  Artist: 'Artist',
};
